import { render, staticRenderFns } from "./Dialog_ChooseStudent.vue?vue&type=template&id=51be244c&scoped=true&"
import script from "./Dialog_ChooseStudent.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be244c",
  null
  
)

export default component.exports